/**
 * @generated SignedSource<<4d472e6b9d686ca778cc85d356b86645>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskStatusEnum = "deactivated" | "error_report" | "first_labeling" | "image_creation" | "problem_creation" | "problem_typing" | "published" | "review" | "second_labeling" | "%future added value";
export type ProblemGeneratorPublishInput = {
  id: string;
  status: TaskStatusEnum;
};
export type ProblemGeneratorPublishButton_problemGeneratorPublishMutation$variables = {
  input: ProblemGeneratorPublishInput;
};
export type ProblemGeneratorPublishButton_problemGeneratorPublishMutation$data = {
  readonly problemGeneratorPublish: {
    readonly generatedProblems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly task: {
            readonly id: string;
            readonly sequence: number;
          } | null;
        };
      }>;
    };
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator">;
  };
};
export type ProblemGeneratorPublishButton_problemGeneratorPublishMutation = {
  response: ProblemGeneratorPublishButton_problemGeneratorPublishMutation$data;
  variables: ProblemGeneratorPublishButton_problemGeneratorPublishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "GeneratedProblemConnection",
  "kind": "LinkedField",
  "name": "generatedProblems",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GeneratedProblemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GeneratedProblem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Task",
              "kind": "LinkedField",
              "name": "task",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sequence",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "before",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "after",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProblemGeneratorPublishButton_problemGeneratorPublishMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProblemGenerator",
        "kind": "LinkedField",
        "name": "problemGeneratorPublish",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProblemGeneratorPublishButton_problemGeneratorPublishMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProblemGenerator",
        "kind": "LinkedField",
        "name": "problemGeneratorPublish",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "ProblemGeneratorHistoryConnection",
            "kind": "LinkedField",
            "name": "histories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProblemGeneratorHistoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProblemGeneratorHistory",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "picture",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDeleted",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "difference",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDifference"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "generatedCount",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "publishedProblemsCount",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "ProblemGeneratorDifference",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "histories(first:10)"
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator_histories",
            "kind": "LinkedHandle",
            "name": "histories"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fb86fc0a3dcf78b7b19aab8da3b3c99c",
    "id": null,
    "metadata": {},
    "name": "ProblemGeneratorPublishButton_problemGeneratorPublishMutation",
    "operationKind": "mutation",
    "text": "mutation ProblemGeneratorPublishButton_problemGeneratorPublishMutation(\n  $input: ProblemGeneratorPublishInput!\n) {\n  problemGeneratorPublish(input: $input) {\n    id\n    generatedProblems {\n      edges {\n        node {\n          id\n          task {\n            id\n            sequence\n          }\n        }\n      }\n    }\n    ...ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator\n  }\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment ProblemGeneratorDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on ProblemGeneratorDifference {\n    generatedCount {\n      __typename\n    }\n    publishedProblemsCount {\n      __typename\n    }\n  }\n}\n\nfragment ProblemGeneratorDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on ProblemGeneratorDifference {\n    generatedCount {\n      ...DiffItem_diff\n    }\n    publishedProblemsCount {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment ProblemGeneratorHistoryDialog_problemGeneratorHistory on ProblemGeneratorHistory {\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...ProblemGeneratorDifferenceCounterLabel_difference\n    ...ProblemGeneratorDifferenceItemList_difference\n  }\n}\n\nfragment ProblemGeneratorHistoryTimelineItem_problemGeneratorHistory on ProblemGeneratorHistory {\n  created\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  type\n}\n\nfragment ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator on ProblemGenerator {\n  histories(first: 10) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...ProblemGeneratorHistoryDialog_problemGeneratorHistory\n        ...ProblemGeneratorHistoryTimelineItem_problemGeneratorHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "5e62259107d90a8fb9ff9deac060faec";

export default node;
